import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './MiniPlay.css'

export default class MiniPlay extends React.PureComponent {

	render() {

		const className = classnames('player-ctrl--toggle', {
			'initiated': this.props.isInitiated,
			'paused': !this.props.isPlaying
		})

		return (
			<div
				className={ className }
				onClick={ this.props.onClick }
			/>
		)
	}
}

MiniPlay.propTypes = {
	isPlaying: PropTypes.bool.isRequired,
	onClick: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/player/controls/miniplay/MiniPlay.jsx